export default {"src":"/_next/static/media/light.84101d57.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};